import React, { useState } from "react";
import axios from "axios";
import AIPromptTextField from "./AIPromptTextField";
import { API_ENDPOINT } from "../../../utils/constants";
import { getHeader } from "../../../utils/util";

const DatabaseAIAssistant = ({
  groupId,
  onSuccess,
  onError,
  placeholder = "Ask AI to help create your list",
}) => {
  const [aiPrompt, setAiPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendPrompt = async (promptText) => {
    if (!groupId) return;

    try {
      setLoading(true);
      const payload = {
        prompt: promptText,
        id: groupId,
      };

      const response = await axios.post(
        `${API_ENDPOINT}/database/database-ai-assistant`,
        payload,
        getHeader()
      );

      // Pass the response data back to the parent
      if (onSuccess) onSuccess(response.data);
    } catch (error) {
      // Pass the error back to the parent to handle UI notifications
      if (onError) onError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AIPromptTextField
      value={aiPrompt}
      onChange={setAiPrompt}
      placeholder={placeholder}
      size="large"
      loading={loading}
      variant="outlined"
      onSend={handleSendPrompt}
      suggestions={[]}
    />
  );
};

export default DatabaseAIAssistant;
